// extracted by mini-css-extract-plugin
export default {"wrapper":"UserButton_wrapper__y-M8L"};